import Model from "../Model";
import tw from "tailwind-styled-components";
import { SideCancelBtn } from "../Styles/InputStyles";
import Config from "../../Config";

const RequestAcceptModal = ({
    setIsReqAccept,
    selectedData,
    refundReqLoading,
    refundReqMutate,

}) => {
    const handleAcceptSubmit = () => {
        refundReqMutate({
            requestId: selectedData?.id,
            status: Config.REQUEST_STATUS.INPROGRESS
        });
    };

    const isLoading = refundReqLoading;

    return (
        <Model
            width="w-full max-w-md"
            setOpenModel={setIsReqAccept}
            title="Confirm Accept Request"
        >
            <WarningText>
                Are you sure you want to accept their request?
            </WarningText>

            <div className="w-full flex justify-between space-x-6 mt-8">
                <SideCancelBtn type="button" onClick={() => setIsReqAccept(false)}>
                    Cancel
                </SideCancelBtn>

                <SubmitBtn
                    onClick={handleAcceptSubmit}
                    disabled={isLoading}
                    className="border border-primary-color bg-white text-primary-color hover:bg-primary-color hover:text-white"
                >
                    {isLoading ? "Loading..." : "Accept"}
                </SubmitBtn>
            </div>
        </Model>
    );
};

const WarningText = tw.p`text-gray-500 text-base mb-4`;
const SubmitBtn = tw.button`
 text-sm w-32  md:w-44 h-12 grid place-items-center disabled:opacity-50 disabled:cursor-not-allowed  md:text-base bg-primary-color hover:bg-hover-color text-white rounded-md shadow-md`;

export default RequestAcceptModal;
